import { render, staticRenderFns } from "./BackStage.vue?vue&type=template&id=0e0c8a4e&scoped=true&lang=pug"
import script from "./BackStage.vue?vue&type=script&lang=js"
export * from "./BackStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0c8a4e",
  null
  
)

export default component.exports